export default class WrongAnswersError extends Error {
  constructor(message: string = 'Check your answers.') {
    super(message);

    this.name = 'WrongAnswersError';
    this.message = message;
  }
}
